export const COOKIE_STORAGE_PREFIX = 'cookies-agreed-sellers-external-HC';
export const WARNING_COOKIES_PORTAL_PREFIX = 'warning-cookies-modal';
